import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-architecture',
	templateUrl:'./ArchitecturePage.html',
	styles: [],
	styleUrls:['./ArchitecturePage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class ArchitecturePage
{
	mdContent_2 = `\`\`\`mermaid
graph TB
  subgraph APP["Your Application"]
    A1["@NgComponent"] --- A2["@NgRoutable"] --- A3["@NgDataService"]
  end
  subgraph PLUGINS["Plugins & Components"]
    P1["WebAwesome"] --- P2["AG Grid"] --- P3["Charts"]
  end
  subgraph CORE["JWebMP Core"]
    C1["HTML/CSS/JS Model"] --- C2["Angular Generator"]
  end
  subgraph FOUNDATION["GuicedEE Foundation"]
    F1["Guice DI"] --- F2["SPI Discovery"] --- F3["Vert.x 5"]
  end
  APP --> PLUGINS --> CORE --> FOUNDATION

\`\`\``;
}
